import styled from "styled-components";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const DashboardCard = styled(Link)`
  width: 100%;
  min-width: 205px;
  height: 150px;
  display: flex;
  flex-direction: column;
  color: rgb(152, 148, 148);
  justify-content: center;
  align-items: left;
  font-size: 25px;
  font-weight: bold;
  line-height: 40px;
  box-shadow: 0px 3px 44px #681e790f;
  border-radius: 8px;
  border: solid 0.8px rgb(167, 167, 167);
  text-decoration: none;
  padding-left: ${(props) => (props.lang === "en" ? "15px" : "0px")};
  padding-right: ${(props) => (props.lang === "ar" ? "15px" : "0px")};
  opacity: 1;

  /* ✅ تعديلات هنا */
  word-break: break-word;
  overflow-wrap: break-word;

  @media (max-width: 600px) {
    font-size: 18px;
    height: auto;
    padding: 10px;
    align-items: center;
    text-align: center;
  }
`;

export default function DashboardCardComponent({ to, children }) {
  const { i18n } = useTranslation();

  return (
    <DashboardCard to={to} lang={i18n.language}>
      {children}
    </DashboardCard>
  );
}
